import { AuthProviderProps } from 'react-oidc-context';
import { AUTHORITY_URL, CLIENT_ID } from './Constants';

export const oidcConfig: AuthProviderProps = {
    authority: AUTHORITY_URL,
    client_id: CLIENT_ID,
    redirect_uri: `${window.location.origin}`,
    post_logout_redirect_uri: window.location.origin,
    onSigninCallback: () => {
        console.log('OIDC - Signin callback triggered');
        window.history.replaceState(
            {},
            document.title
        );
    },
    scope: 'openid profile email',
    response_type: 'code',
    automaticSilentRenew: true,
    loadUserInfo: false
};
